import React, { Component } from "react";
import ReCaptcha from "../common/recaptcha.component";
import Validator from "../../utils/Validator";
import {
  REGISTRATION_USERNAME_VALIDATION_ERROR,
  REGISTRATION_USERNAME_NOTE,
  REGISTRATION_CELLPHONE_VALIDATION_ERROR,
  REGISTRATION_FIRSTNAME_VALIDATION_ERROR
} from "../../utils/constants";
import TaggingHelper from "../../tagging/tagging-helper";
import PrivacyConsentCheckbox from "./PrivacyConsentCheckbox";

class CreateProfile extends Component {
  defaultState = {
    name: "",
    cellnum: "",
    username: "",
    token: null,
    firstNameError: true,
    userNameError: true,
    cellNumberError: true,
    usernameActive: false,
    cellphoneNumberActive: false,
    firstnameActive: false,
    privacyConsentChecked: false
  };

  constructor(props) {
    super(props);
    if (props.data && props.data.previousState) {
      this.state = {
        ...props.data.previousState,
        token: null
      };
    } else {
      this.state = this.defaultState;
    }
  }

  componentDidMount() {
    TaggingHelper.createProfileLandingEvent();
  }

  _onVerifyCallback = (token) => {
    this.setState({
      token: token
    });
  };

  _onExpiredCallback = () => {
    this.setState({ token: null });
  };

  activateField = (e) => {
    this.setState({
      [`${e.target.name}Active`]: true
    });
  };

  disableField = (e) => {
    this.setState({
      [`${e.target.name}Active`]: false
    });
  };

  _onUserNameChange = (e) => {
    this.setState({
      userNameError: !Validator.isValidUsername(e.target.value, true),
      username: e.target.value
    });
  };

  _onCellphoneNumberChange = (e) => {
    this.setState({
      cellnum: e.target.value,
      cellNumberError: !Validator.isValidCellphone(e.target.value)
    });
  };

  _onNameChange = (e) => {
    this.setState({
      name: e.target.value,
      firstNameError: !Validator.isValidFirstName(e.target.value)
    });
  };

  onPrivacyConsentChange = (e) => {
    this.setState({
      privacyConsentChecked: e.target.checked
    });
  };

  gotoNext = () => {
    this.props.goto("CREATE_PASSWORD", { currentState: this.state });
  };

  render() {
    const { goto } = this.props;
    const {
      firstnameActive,
      name,
      firstNameError,
      usernameActive,
      username,
      userNameError,
      cellphoneNumberActive,
      cellnum,
      cellNumberError,
      token,
      privacyConsentChecked
    } = this.state;
    return (
      <React.Fragment>
        <div className="card-header">
          <h2>Create Account</h2>
          <p>
            Already have an account ?{" "}
            <button
              type="button"
              className="button-link"
              onClick={() => goto("LOGIN")}
              automationid="REGISTRATION_FORM_CREATEPROFILE_1"
            >
              Log in
            </button>
          </p>
        </div>
        <div className="field-group registration-field-group">
          <label className={firstnameActive || name ? "active" : ""}>
            {"First name"}
          </label>
          <input
            onChange={this._onNameChange}
            value={name}
            type="text"
            name="firstname"
            automationid="REGISTRATION_FORM_CREATEPROFILE_2"
            className={
              !firstnameActive && name && firstNameError ? "error" : ""
            }
            onFocus={this.activateField}
            onBlur={this.disableField}
          />
          {!firstnameActive && name && firstNameError && (
            <p className="infield-error-label">
              {REGISTRATION_FIRSTNAME_VALIDATION_ERROR}
            </p>
          )}
        </div>
        <div className="field-group registration-field-group">
          <label className={usernameActive || username ? "active" : ""}>
            {"Email address"}
          </label>
          <input
            onChange={this._onUserNameChange}
            value={username}
            name="username"
            onFocus={this.activateField}
            onBlur={this.disableField}
            automationid="REGISTRATION_FORM_CREATEPROFILE_3"
            className={
              !usernameActive && username && userNameError ? "error" : ""
            }
          />
          {!usernameActive && username && userNameError ? (
            <p className="infield-error-label">
              {REGISTRATION_USERNAME_VALIDATION_ERROR}
            </p>
          ) : (
            <p className="user_name">{REGISTRATION_USERNAME_NOTE}</p>
          )}
        </div>
        <div className="field-group registration-field-group">
          <label className={cellphoneNumberActive || cellnum ? "active" : ""}>
            {"Cellphone number"}
          </label>
          <input
            onChange={this._onCellphoneNumberChange}
            value={cellnum}
            name="cellphoneNumber"
            onFocus={this.activateField}
            onBlur={this.disableField}
            automationid="REGISTRATION_FORM_CREATEPROFILE_4"
            className={
              !cellphoneNumberActive && cellnum && cellNumberError
                ? "error"
                : ""
            }
          />
          {!cellphoneNumberActive && cellnum && cellNumberError && (
            <p className="infield-error-label">
              {REGISTRATION_CELLPHONE_VALIDATION_ERROR}
            </p>
          )}
        </div>
        <div className="captcha-wrapper registration-captcha-wrapper">
          <ReCaptcha
            sitekey={"6LdNAAwUAAAAALEhZyYgkqFtXUPKVhD5Fj2XaWUm"}
            verifyCallback={this._onVerifyCallback}
            expiredCallback={this._onExpiredCallback}
          />
        </div>
        <div className="registration-privacy-wrapper">
          <PrivacyConsentCheckbox
            checked={privacyConsentChecked}
            onChange={this.onPrivacyConsentChange}
          />
        </div>
        <div className="action-button-wrapper">
          <button
            className="btn btnRed"
            type="submit"
            disabled={
              userNameError ||
              firstNameError ||
              cellNumberError ||
              !token ||
              !privacyConsentChecked
            }
            onClick={this.gotoNext}
            automationid="REGISTRATION_FORM_CREATEPROFILE_5"
          >
            Next
          </button>
        </div>
      </React.Fragment>
    );
  }
}

export default CreateProfile;
